import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';
import './CalendarModal.css';

export default function UserSettingsModal({ userData, onClose }) {
  const { currentUser } = useAuth();
  const { showToast } = useToast();
  const [displayName, setDisplayName] = useState(userData?.displayName || currentUser?.displayName || '');
  const [saving, setSaving] = useState(false);

  async function handleSaveName(e) {
    e.preventDefault();
    if (!displayName.trim()) return;

    try {
      setSaving(true);
      await updateDoc(doc(db, 'users', currentUser.uid), {
        displayName: displayName.trim()
      });
      showToast('تم تحديث الاسم بنجاح', 'success');
    } catch (error) {
      console.error('Error updating name:', error);
      showToast('حدث خطأ أثناء تحديث الاسم', 'error');
    } finally {
      setSaving(false);
    }
  }


  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content calendar-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>إعدادات الحساب</h2>
          <button className="close-btn" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Email (read-only) */}
        <div className="form-group">
          <label>البريد الإلكتروني</label>
          <input
            type="email"
            value={currentUser?.email || ''}
            disabled
            style={{ opacity: 0.6, cursor: 'not-allowed' }}
          />
        </div>

        {/* Display Name */}
        <form onSubmit={handleSaveName}>
          <div className="form-group">
            <label>الاسم</label>
            <input
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              placeholder="أدخل اسمك"
              disabled={saving}
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={saving || !displayName.trim() || displayName.trim() === (userData?.displayName || '')}
            style={{ width: '100%', marginBottom: '24px' }}
          >
            {saving ? 'جاري الحفظ...' : 'حفظ الاسم'}
          </button>
        </form>

      </div>
    </div>
  );
}
